export async function getApi(url: string, path: string, apiToken?: string, queryParameters?: any): Promise<any> {
  try {
    if (queryParameters) {
      const queryString = Object.keys(queryParameters)
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(queryParameters[key]))
        .join("&");
      path += "?" + queryString;
    }

    // console.log(path);
    return new Promise(function (resolve, reject) {
      const xhttp = new XMLHttpRequest();
      xhttp.open("GET", `https://${url}/${path}`, true);
      if (apiToken) {
        xhttp.setRequestHeader("Authorization", "Bearer " + apiToken);
      }
      xhttp.onload = function () {
        const status = xhttp.status;
        if (status == 200) {
          const response = JSON.parse(xhttp.responseText);
          // Handle both legacy "message" format and new API format
          resolve(response.message || response);
        } else {
          reject(status);
        }
      }
      xhttp.onerror = function () {
        reject({
            status: this.status,
            statusText: xhttp.statusText
        });
      }
      xhttp.send();
    });
  } catch (e) {
    // throw new Error(e as string)
  }
}

export async function postApi(url: string, path: string, data: object, apiToken?: string) {
  return new Promise(function (resolve, reject) {
    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", `https://${url}/${path}`, true);
    xhttp.setRequestHeader("Content-Type", "application/json");
    if (apiToken) {
      xhttp.setRequestHeader("Authorization", "Bearer " + apiToken);
    }
    xhttp.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhttp.response);
      } else {
        reject({
          status: this.status,
          statusText: xhttp.statusText
        });
      }
    }
    xhttp.onerror = function () {
      reject({
          status: this.status,
          statusText: xhttp.statusText
      });
  };
    xhttp.send(JSON.stringify(data));
  })
}

export async function putApi(url: string, path: string, data: object, apiToken?: string) {
  return new Promise(function (resolve, reject) {
    const xhttp = new XMLHttpRequest();
    xhttp.open("PUT", `https://${url}/${path}`, true);
    xhttp.setRequestHeader("Content-Type", "application/json");
    if (apiToken) {
      xhttp.setRequestHeader("Authorization", "Bearer " + apiToken);
    }
    xhttp.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhttp.response);
      } else {
        reject({
          status: this.status,
          statusText: xhttp.statusText
        });
      }
    }
    xhttp.onerror = function () {
      reject({
          status: this.status,
          statusText: xhttp.statusText
      });
  };
    xhttp.send(JSON.stringify(data));
  })
}

export async function deleteApi(url: string, path: string, apiToken?: string, queryParameters?: any) {
  if (queryParameters) {
    const queryString = Object.keys(queryParameters)
      .map((key) => key + "=" + queryParameters[key])
      .join("&");
    path += "?" + queryString;
  }

  return new Promise(function (resolve, reject) {
    const xhttp = new XMLHttpRequest();
    xhttp.open("DELETE", `https://${url}/${path}`, true);
    xhttp.setRequestHeader("Content-Type", "application/json");
    if (apiToken) {
      xhttp.setRequestHeader("Authorization", "Bearer " + apiToken);
    }
    xhttp.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhttp.response);
      } else {
        reject({
          status: this.status,
          statusText: xhttp.statusText
        });
      }
    }
    xhttp.onerror = function () {
      reject({
          status: this.status,
          statusText: xhttp.statusText
      });
  };
    xhttp.send();
  })
}